<script>
import Loading from '../../components/loading.vue';
import Order from '../../components/mineTable/order.vue';
export default {
    name: "order",
    data() {
        return {
            list: [],
            isLoading: false,
            page: 1,
            totalPage: 1,
        };
    },
    computed: {},
    components: {
        Loading,
        Order,
    },
    mounted() {
        this.getOrderList();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 获取订单列表
        getOrderList() {
            this.isLoading = true;
            this.$store.dispatch('getShopOrderList', {
                page: this.page,
                limit: 10,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.totalPage = result.data.last_page;
                    this.list = this.list.concat(result.data.list);
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 加载更多订单
        loadMore() {
            if (this.page < this.totalPage) {
                this.page++;
                this.getRefundList();
            }
        },
    },
};
</script>

<template>
    <div class="order">
        <p class="title only_pc">我的订单</p>
        <p class="no_more" v-if="list.length == 0">你还没有选购商品<router-link to="/shop">立即去购物&gt;&gt;</router-link></p>
        <Order v-else :data="list"/>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <div class="flex justify_center" v-else-if="page < totalPage">
            <p class="load_more" @click="loadMore">查看更多</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.order{
    .load_more{
        text-align: center;
        padding: .2rem 0;
        color: #666;
        font-size: .2rem;
        cursor: pointer;
    }
    .order_list{
        .tr{
            .td{
                &:nth-of-type(1){
                    width: 38%;
                }
                &:nth-of-type(2){
                    width: 15%;
                }
                &:nth-of-type(3){
                    width: 20%;
                }
                &:nth-of-type(4){
                    width: 27%;
                }
            }
        }
    }
}
</style>